/**
 * defa.collections.finders
 * A Collection of Finder
 * @version 1.2.0
 */
import Finder from 'scripts/defa/control/map/model-finder';

const Finders = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : Finder,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );


export default Finders